/* GranizShu — comportamiento del tema. Sin dependencias externas. */
(function () {
  'use strict';

  /* --------------------------------------------------- Scroll reveal ---- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.reveal:not(.revealed)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------- Nav ---- */
  function initNav(root) {
    var nav = (root || document).querySelector('[data-nav]');
    if (!nav) return;

    if (nav.hasAttribute('data-nav-transparent')) {
      var onScroll = function () {
        nav.classList.toggle('nav--scrolled', window.scrollY > 80);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var burger = nav.querySelector('[data-nav-burger]');
    var mobile = document.getElementById('navMobile');
    if (!burger || !mobile) return;

    function open() {
      mobile.classList.add('nav-mobile--open');
      mobile.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      mobile.classList.remove('nav-mobile--open');
      mobile.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    burger.addEventListener('click', open);
    mobile.querySelectorAll('[data-nav-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ------------------------------------------------------ Sticky CTA ---- */
  function initStickyCta(root) {
    var bar = (root || document).querySelector('[data-sticky-cta]');
    if (!bar) return;
    var shown = false;
    window.addEventListener('scroll', function () {
      var scrolled = window.scrollY > window.innerHeight * 0.7;
      if (scrolled && !shown) {
        bar.classList.add('sticky-cta--visible');
        bar.setAttribute('aria-hidden', 'false');
        shown = true;
      } else if (!scrolled && shown) {
        bar.classList.remove('sticky-cta--visible');
        bar.setAttribute('aria-hidden', 'true');
        shown = false;
      }
    }, { passive: true });
  }

  /* --------------------------------------------- Galería de producto ---- */
  function initProductGallery(root) {
    (root || document).querySelectorAll('[data-product-gallery]').forEach(function (gal) {
      var main = gal.querySelector('[data-gallery-main]');
      if (!main) return;
      gal.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-src');
          var srcset = btn.getAttribute('data-srcset');
          if (src) main.setAttribute('src', src);
          if (srcset) main.setAttribute('srcset', srcset);
          gal.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
            b.classList.remove('product__thumb--active');
          });
          btn.classList.add('product__thumb--active');
        });
      });
    });
  }

  /* --------------------------------------- Selector de variantes -------- */
  function initVariantPickers(root) {
    (root || document).querySelectorAll('[data-variant-picker]').forEach(function (form) {
      var data = form.querySelector('[data-variants-json]');
      if (!data) return;
      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }

      var selects = form.querySelectorAll('[data-option-index]');
      var idInput = form.querySelector('[data-variant-id]');
      var priceEl = form.querySelector('[data-variant-price]');
      var compareEl = form.querySelector('[data-variant-compare]');
      var submit = form.querySelector('[data-add-button]');
      var soldOut = form.querySelector('[data-sold-out]');

      function money(cents) {
        var fmt = form.getAttribute('data-money-format') || '{{amount}}';
        var value = (cents / 100).toFixed(2).replace('.', ',');
        /* El formato de la tienda puede ser {{amount}}, {{amount_with_comma_separator}}, etc. */
        return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, value);
      }

      function update() {
        var chosen = [];
        selects.forEach(function (s) { chosen[parseInt(s.getAttribute('data-option-index'), 10)] = s.value; });
        var match = variants.filter(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        })[0];

        if (!match) {
          if (submit) { submit.setAttribute('disabled', 'disabled'); submit.classList.add('btn--disabled'); }
          if (soldOut) soldOut.hidden = false;
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = money(match.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (submit) {
          if (match.available) {
            submit.removeAttribute('disabled');
            submit.classList.remove('btn--disabled');
          } else {
            submit.setAttribute('disabled', 'disabled');
            submit.classList.add('btn--disabled');
          }
        }
        if (soldOut) soldOut.hidden = !!match.available;

        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }

      selects.forEach(function (s) { s.addEventListener('change', update); });
    });
  }

  /* ---------------------------------------------------- Cantidad -------- */
  function initQty(root) {
    (root || document).querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var next = (parseInt(input.value, 10) || 1) + step;
          input.value = next < 1 ? 1 : next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* -------------------------------------------- Carrito: auto-submit ---- */
  function initCartForm(root) {
    (root || document).querySelectorAll('[data-cart-form]').forEach(function (form) {
      form.querySelectorAll('[data-cart-qty]').forEach(function (input) {
        input.addEventListener('change', function () { form.submit(); });
      });
    });
  }

  function boot(root) {
    initReveal(root);
    initNav(root);
    initStickyCta(root);
    initProductGallery(root);
    initVariantPickers(root);
    initQty(root);
    initCartForm(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* El editor de temas recarga secciones sueltas: hay que re-enganchar todo
     o la sección editada se queda sin JS (y con el contenido invisible). */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initReveal(e.target); });
})();
